/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import moment from 'moment'
import R from 'ramda'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { MenuItem, RaisedButton, ListItem, Divider, List, FontIcon, Checkbox } from 'material-ui'
import { Tooltip, withStyles } from '@material-ui/core'
import { SelectField, DatePicker, AutoComplete, TextField } from 'generic/form'
import Card from 'generic/card/Card'

import * as actions from 'actions/ApplicantPrestation'
import * as interpreterActions from 'actions/Interpreter'
import * as entityActions from 'actions/Entity'
import * as identityActions from 'actions/Identity'
import * as constants from 'constants/Prestation'
import * as loginConstants from 'constants/Login'

class SearchToolBar extends React.Component {
  constructor (props) {
    super(props)
    autoBind(this)

    this.data = {
      uid: undefined,
      invoice_aba_code: undefined,
      invoice_date: undefined,
      before: undefined,
      after: undefined,
      languages: [],
      origines: [],
      prestationTypes: [],
      workflowSteps: [],
      interpreters: [],
      applicant_entities: [],
      applicant_identities: [],
      consumer_entities: [],
      consumer_identities: [],
      payingCustomers: [],
      beneficiary_number: undefined,
      invited_interpreters: [],
      address: undefined,
      page: 1,
    }

    this.state = {
      data: this.data,
      errors: {},
      cleanAutoCompleteSearch: false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.cleanAutoCompleteSearch !== this.state.cleanAutoCompleteSearch) {
      this.setState({
        cleanAutoCompleteSearch: false
      })
    }
  }

  handleSetStartDateRef(field) {
    this.startDatePicker = field || null
  }

  handleSetEndDateRef(field) {
    this.endDatePicker = field || null
  }

  handleSetInvoiceDateRef(field) {
    this.invoiceDatePicker = field || null
  }

  handleChange(event, value) {
    const name = event.target.name

    this.setState({
      data: {
        ...this.state.data,
        [name]: value || undefined
      }
    })
  }

  handleDateFormatChange(event, value) {
    const name = event.target.name
    this.setState({
      errors: {
        ...this.state.errors,
        [name]: undefined
      }
    })

    let date = value === '' ? undefined : value

    if (date && date.length === 10) {
      const formattedDate = moment(value, 'DD.MM.YYYY')

      if (moment(formattedDate, 'YYYY-MM-DD').isValid()) {
        date = moment(formattedDate).format('YYYY-MM-DD')
      } else {
        this.setState({
          errors: {
            ...this.state.errors,
            [name]: this.props.intl.formatMessage(constants.messages.DATE_INVALID)
          }
        })

        return
      }
    }

    this.handleChange(event, date)
  }

  handleDateChange(name, value) {
    const date = moment(value).format('YYYY-MM-DD')
    this.handleChange(name, date)
  }

  handleAddressChange(event, value) {
    this.setState({
      data: {
        ...this.state.data,
        [event]: value ? value.address : ''
      }
    })
  }

  updateAutocomplete(name, value) {
    if (value && this.state.data[name].filter((v) => {return v.uid === value.uid})[0]) {
      return
    }

    this.setState({
      data: {
        ...this.state.data,
        [name]: value ? [...this.state.data[name], value] : this.state.data[name]
      }
    })
  }

  deleteAutocomplete(name, value) {
    this.setState({
      data: {
        ...this.state.data,
        [name]: this.state.data[name].filter((v) => v.uid !== value)
      }
    })
  }

  handleMultiSelectChange(event, index, values) {
    const name = event.target.name

    this.setState({
      data: {
        ...this.state.data,
        [name]: values
      }
    })
  }

  transformInterpreter(interpreter) {
    return {
      ...interpreter,
      display: interpreter.identities[0].first_name + ' ' + interpreter.identities[0].last_name
    }
  }

  transformConsumer(consumer) {
    return {
      ...consumer,
      display: consumer.identities[0].first_name + ' ' + consumer.identities[0].last_name + ' - ' + consumer.entities[0].name,
      'short-display': consumer.identities[0].first_name + ' ' + consumer.identities[0].last_name
    }
  }

  transformEntity(entity) {
    return {
      ...entity,
      display: entity.name
    }
  }

  transformIdentity(identity) {
    return {
      ...identity,
      display: identity.first_name + ' ' + identity.last_name
    }
  }

  setIdentityText(searchText) {
    this.setState({identityText: searchText})
  }

  handleCleanSearch() {
    this.setState({
      data: this.data,
      cleanAutoCompleteSearch: true,
    })
  }

  search () {
    const data = {
      ...this.state.data,
      page: 1
    }
    
    this.props.search(data)
  }

  render () {
    const startDate = this.state.data &&
                      this.state.data.after &&
                      this.state.data.after.length === 10
                        ? moment(this.state.data.after).format('DD.MM.YYYY')
                        : this.state.data &&
                          this.state.data.after
                          ? this.state.data.after
                          : ''

    const endDate = this.state.data &&
                    this.state.data.before &&
                    this.state.data.before.length === 10
                      ? moment(this.state.data.before).format('DD.MM.YYYY')
                      : this.state.data &&
                        this.state.data.before
                        ? this.state.data.before
                        : ''

    const invoiceDate = this.state.data &&
                        this.state.data.invoice_date &&
                        this.state.data.invoice_date.length === 10
                          ? moment(this.state.data.invoice_date).format('DD.MM.YYYY')
                          : this.state.data &&
                            this.state.data.invoice_date
                            ? this.state.data.invoice_date
                            : ''

    return (
      <Card className='full-height-card'>
        <div className='row'>
          <div className='col-md-12 col-xs-12'>
            <List>
              <ListItem
                disabled
                key={0}
                style={{margin: 0, padding: '0px 15px 0px 15px'}}
                nestedListStyle={{padding: 0}}
                primaryText={
                  <div className='row'>
                    <div
                      className='col-md-4 col-xs-12'
                      style={{paddingTop: 10, fontSize: '1vw'}}
                    >
                      {this.props.intl.formatMessage(constants.messages.SEARCH_TOOL_TITLE)}
                    </div>
                    <div
                      className='col-md-4 col-xs-12'
                    >
                      <RaisedButton
                        label={this.props.intl.formatMessage(constants.messages.CLEAN_SEARCH)}
                        primary={true}
                        icon={<FontIcon className='material-icons'>refresh</FontIcon>}
                        style={{float: 'right', minWidth: 125, boxShadow: 'none'}}
                        onClick={this.handleCleanSearch}
                      />
                    </div>

                    <div
                      className='col-md-4 col-xs-12'
                    >
                      <RaisedButton
                        label={this.props.intl.formatMessage(constants.messages.HISTORY_SEARCH)}
                        primary={true}
                        onClick={this.search}
                        icon={<FontIcon className='material-icons'>search</FontIcon>}
                        style={{float: 'right', minWidth: 125, boxShadow: 'none'}}
                      />
                    </div>
                  </div>
                }
              />
            </List>
          </div>
        </div>

        <Divider/>

        <div style={{ marginRight: '.9rem', marginLeft: '.9rem' }}>
          <div className='row'>
            <div className='col-md-6 col-xs-12'>
              <TextField
                divStyle={{height: 72}}
                name='uid'
                value={this.state.data.uid || ''}
                onChange={this.handleChange}
                floatingLabelText={this.props.intl.formatMessage(constants.messages.SEARCH_UID_LABEL)}
              />
            </div>
            {
              this.props.user.is_staff ||
              this.props.user.role === loginConstants.PAYING_CUSTOMER_ROLE
                ? <div className='col-md-6 col-xs-12'>
                  <TextField
                    divStyle={{height: 72}}
                    name='invoice_aba_code'
                    value={this.state.data.invoice_aba_code || ''}
                    onChange={this.handleChange}
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.SEARCH_INVOICE_ABA_CODE_LABEL)}
                  />
                </div>
                : undefined
            }
          </div>

          <div className='category-title'>{this.props.intl.formatMessage(constants.messages.SEARCH_DATE_LABEL)}</div>

          <div className='row'>
            <div
              className='col-md-6 col-xs-12'
              style={{position: 'relative'}}
            >
              <TextField
                name='after'
                value={startDate}
                floatingLabelText={this.props.intl.formatMessage(constants.messages.AFTER_LABEL)}
                onChange={this.handleDateFormatChange}
                mask='99.99.9999'
                errorText={R.path(['after'], this.state.errors)}
              />

              <DatePicker
                name='after'
                divStyle={{display: 'none'}}
                locale={this.props.intl.locale}
                onChange={this.handleDateChange}
                getField={this.handleSetStartDateRef}
              />

              <FontIcon
                onClick={() => this.startDatePicker.focus()}
                className='material-icons'
                style={{
                  margin: '20px 5px 0 0',
                  top: 20,
                  right: 0,
                  position: 'absolute',
                  cursor: 'pointer'
                }}
              >today
              </FontIcon>
            </div>

            <div
              className='col-md-6 col-xs-12'
              style={{position: 'relative'}}
            >
              <TextField
                name='before'
                value={endDate}
                floatingLabelText={this.props.intl.formatMessage(constants.messages.BEFORE_LABEL)}
                onChange={this.handleDateFormatChange}
                mask='99.99.9999'
                errorText={R.path(['before'], this.state.errors)}
              />

              <DatePicker
                name='before'
                divStyle={{display: 'none'}}
                locale={this.props.intl.locale}
                onChange={this.handleDateChange}
                getField={this.handleSetEndDateRef}
              />

              <FontIcon
                onClick={() => this.endDatePicker.focus()}
                className='material-icons'
                style={{
                  margin: '20px 5px 0 0',
                  top: 20,
                  right: 0,
                  position: 'absolute',
                  cursor: 'pointer'
                }}
              >today
              </FontIcon>
            </div>
          </div>

          <div className='row'>
            {
              this.props.user.is_staff ||
              this.props.user.role === loginConstants.PAYING_CUSTOMER_ROLE
                ? <div
                  className='col-md-6 col-xs-12'
                  style={{position: 'relative'}}
                >
                  <TextField
                    name='invoice_date'
                    value={invoiceDate}
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.SEARCH_INVOICE_DATE_LABEL)}
                    onChange={this.handleDateFormatChange}
                    mask='99.99.9999'
                    errorText={R.path(['invoice_date'], this.state.errors)}
                  />

                  <DatePicker
                    name='invoice_date'
                    divStyle={{display: 'none'}}
                    locale={this.props.intl.locale}
                    onChange={this.handleDateChange}
                    getField={this.handleSetInvoiceDateRef}
                  />

                  <FontIcon
                    onClick={() => this.invoiceDatePicker.focus()}
                    className='material-icons'
                    style={{
                      margin: '20px 5px 0 0',
                      top: 20,
                      right: 0,
                      position: 'absolute',
                      cursor: 'pointer'
                    }}
                  >today
                  </FontIcon>
                </div>
                : undefined
            }

            <div 
              className='col-md-6 col-xs-12'
              style={styles.checkboxCell}
            >
              <Checkbox
                name='is_archived'
                label={
                  <React.Fragment>
                    {this.props.intl.formatMessage(constants.messages.ARCHIVED)}
                    &nbsp;
                    <InfoTooltip 
                      placement="right" 
                      title={this.props.intl.formatMessage(constants.messages.ARCHIVED_TOOLTIP)}
                    >
                      <FontIcon 
                        className='material-icons'
                        style={styles.infoIcon}
                      >
                        info
                      </FontIcon>
                    </InfoTooltip>
                  </React.Fragment>
                }
                checked={this.state.data.is_archived}
                style={styles.checkbox}
                onCheck={(event, value) => this.handleChange(event, value)}
              />              
            </div>
          </div>

          <div className='category-title'>{this.props.intl.formatMessage(constants.messages.CONTRIBUTORS_SEARCH_LABEL)}</div>
          <div className='row'>
            <div className='col-md-6 col-xs-12'>
              {
                this.props.user.role === loginConstants.INTERPRETER_ROLE
                  ? <TextField
                    disabled={true}
                    name='interpreter'
                    value={this.props.user.identityName}
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_INTERPRETER_LABEL)}
                  />
                  : <AutoComplete
                    name='interpreters'
                    textKey='display'
                    valueKey='uid'
                    searchKey='text'
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_INTERPRETER_LABEL)}
                    url={interpreterActions.SIMPLE_INTERPRETERS_URL}
                    transformData={this.transformInterpreter}
                    updateItem={this.updateAutocomplete}
                    multi={true}
                    values={this.state.data.interpreters}
                    deleteValue={this.deleteAutocomplete}
                    cleanAutoCompleteSearch={this.state.cleanAutoCompleteSearch}
                  />
              }
            </div>
            <div className='col-md-6 col-xs-12'>
              {
                this.props.user.role === loginConstants.PAYING_CUSTOMER_ROLE
                  ? <TextField
                    disabled={true}
                    name='paying_customer_entity'
                    value={this.props.user.entityName}
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_PAYING_CUSTOMER_LABEL)}
                  />
                  : <AutoComplete
                    name='payingCustomers'
                    textKey='display'
                    valueKey='uid'
                    searchKey='name'
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_PAYING_CUSTOMER_LABEL)}
                    url={entityActions.ENTITY_LIST_URL}
                    transformData={this.transformEntity}
                    updateItem={this.updateAutocomplete}
                    multi={true}
                    values={this.state.data.payingCustomers}
                    deleteValue={this.deleteAutocomplete}
                    cleanAutoCompleteSearch={this.state.cleanAutoCompleteSearch}
                  />
              }
            </div>
          </div>

          <div className='row'>
            <div className='col-md-6 col-xs-12'>
              {
                this.props.user.role === loginConstants.APPLICANT_ROLE &&
                !this.props.user.is_staff
                  ? <TextField
                    disabled={true}
                    name='applicant_entity'
                    value={this.props.user.entityName}
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_APPLICANT_ENTITY_LABEL)}
                  />
                  : <AutoComplete
                    name='applicant_entities'
                    textKey='display'
                    valueKey='uid'
                    searchKey='name'
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_APPLICANT_ENTITY_LABEL)}
                    url={entityActions.APPLICANT_ENTITY_LIST_URL}
                    transformData={this.transformEntity}
                    updateItem={this.updateAutocomplete}
                    multi={true}
                    values={this.state.data.applicant_entities}
                    deleteValue={this.deleteAutocomplete}
                    cleanAutoCompleteSearch={this.state.cleanAutoCompleteSearch}
                  />
              }
            </div>
            <div className='col-md-6 col-xs-12'>
              {
                this.props.user.role === loginConstants.APPLICANT_ROLE &&
                this.props.user.viewType === loginConstants.APPLICANT_PRESTATION_IDENTITY_VIEW_TYPE &&
                !this.props.user.is_staff
                  ? <TextField
                    disabled={true}
                    name='applicant_identity'
                    value={this.props.user.identityName}
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_APPLICANT_IDENTITY_LABEL)}
                  />
                  : <AutoComplete
                    name='applicant_identities'
                    textKey='display'
                    valueKey='uid'
                    searchKey='text'
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_APPLICANT_IDENTITY_LABEL)}
                    url={identityActions.APPLICANTS_IDENTITY_LIST_URL}
                    transformData={this.transformIdentity}
                    updateItem={this.updateAutocomplete}
                    onUpdateInput={this.setIdentityText}
                    multi={true}
                    values={this.state.data.applicant_identities}
                    deleteValue={this.deleteAutocomplete}
                    cleanAutoCompleteSearch={this.state.cleanAutoCompleteSearch}
                  />
              }
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 col-xs-12'>
              {
                this.props.user.role === loginConstants.APPLICANT_ROLE &&
                !this.props.user.is_staff &&
                (this.props.user.viewType === loginConstants.APPLICANT_PRESTATION_ENTITY_VIEW_TYPE ||
                 this.props.user.viewType === loginConstants.APPLICANT_PRESTATION_IDENTITY_VIEW_TYPE)
                  ? <TextField
                    disabled={true}
                    name='consumer_entity'
                    value={this.props.user.entityName}
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_CONSUMER_ENTITY_LABEL)}
                  />
                  : <AutoComplete
                    name='consumer_entities'
                    textKey='display'
                    valueKey='uid'
                    searchKey='name'
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_CONSUMER_ENTITY_LABEL)}
                    url={entityActions.CONSUMER_ENTITY_LIST_URL}
                    transformData={this.transformEntity}
                    updateItem={this.updateAutocomplete}
                    multi={true}
                    values={this.state.data.consumer_entities}
                    deleteValue={this.deleteAutocomplete}
                    cleanAutoCompleteSearch={this.state.cleanAutoCompleteSearch}
                  />
              }
            </div>
            <div className='col-md-6 col-xs-12'>
              <AutoComplete
                name='consumer_identities'
                textKey='display'
                valueKey='uid'
                searchKey='text'
                floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_CONSUMER_IDENTITY_LABEL)}
                url={identityActions.CONSUMERS_IDENTITY_LIST_URL}
                transformData={this.transformIdentity}
                updateItem={this.updateAutocomplete}
                onUpdateInput={this.setIdentityText}
                multi={true}
                values={this.state.data.consumer_identities}
                deleteValue={this.deleteAutocomplete}
                cleanAutoCompleteSearch={this.state.cleanAutoCompleteSearch}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 col-xs-12'>
              <TextField
                name='beneficiary_number'
                floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_BENEFICIARY_NUMBER_LABEL)}
                value={this.state.data.beneficiary_number || ''}
                onChange={this.handleChange}
              />
            </div>

            <div className='col-md-6 col-xs-12'>
              <AutoComplete
                name='address'
                valueKey='uid'
                textKey='address'
                searchKey='address'
                floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_ADDRESS_LABEL)}
                url={actions.ADDRESSES_URL}
                updateItem={this.handleAddressChange}
                value={R.path(['address'], this.state.data)}
                cleanAutoCompleteSearch={this.state.cleanAutoCompleteSearch}
              />
            </div>
          </div>

          <div className='category-title'>{this.props.intl.formatMessage(constants.messages.SEARCH_OTHER_CRITERIAS_LABEL)}</div>
          {
            this.props.user.is_staff
              ? <div className='row'>
                <div className='col-md-6 col-xs-12'>
                  <AutoComplete
                    name='invited_interpreters'
                    textKey='display'
                    valueKey='uid'
                    searchKey='text'
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.HISTORY_INVITED_INTERPRETER_LABEL)}
                    url={interpreterActions.SIMPLE_INTERPRETERS_URL}
                    transformData={this.transformInterpreter}
                    updateItem={this.updateAutocomplete}
                    multi={true}
                    values={R.path(['invited_interpreters'], this.state.data)}
                    deleteValue={this.deleteAutocomplete}
                    cleanAutoCompleteSearch={this.state.cleanAutoCompleteSearch}
                  />
                </div>
              </div>
              : null
          }
          <div className='row'>
            <div 
                className='col-md-6 col-xs-12'
                style={{
                    width: '0px',
                    }}>
              <SelectField
                name='languages'
                sourceKey='languages'
                value={this.state.data.languages}
                multiple={true}
                onChange={this.handleMultiSelectChange}
                floatingLabelText={this.props.intl.formatMessage(constants.messages.LANGUAGES_LABEL)}
              >
                {
                  this.props.languages.map((language, i) => (
                    <MenuItem
                      insetChildren={true}
                      checked={!!(
                        this.state.data.languages.length &&
                        this.state.data.languages.indexOf(language.uid) > -1
                      )}
                      primaryText={language.value}
                      value={language.uid}
                      key={i}
                    />
                  ))
                }
              </SelectField>
            </div>
            <div 
                className='col-md-6 col-xs-12'
                style={{
                    width: '0px',
                    }}>
              <SelectField
                name='origines'
                sourceKey='origines'
                value={this.state.data.origines}
                multiple={true}
                onChange={this.handleMultiSelectChange}
                floatingLabelText={this.props.intl.formatMessage(constants.messages.ORIGIN_LABEL)}
              >
                {
                  this.props.origines.map((origine, i) => (
                    <MenuItem insetChildren={true}
                      checked={
                        !!(this.state.data.origines.length &&
                           this.state.data.origines.indexOf(origine.uid) > -1)}
                      primaryText={origine.nationality}
                      value={origine.uid}
                      key={i} />
                  ))
                }
              </SelectField>
            </div>
          </div>
          <div className='row'>
            <div 
                className='col-md-6 col-xs-12'
                style={{
                    width: '0px',
                    }}>
              <SelectField
                name='prestationTypes'
                sourceKey='prestationTypes'
                value={this.state.data.prestationTypes}
                autoWidth
                multiple={true}
                onChange={this.handleMultiSelectChange}
                floatingLabelText={this.props.intl.formatMessage(constants.messages.PRESTATION_TYPE_LABEL)}
              >
                {
                  this.props.prestationTypes.map((prestationType, i) => (
                    <MenuItem
                      insetChildren={true}
                      checked={
                        !!(this.state.data.prestationTypes.length &&
                           this.state.data.prestationTypes.indexOf(prestationType.uid) > -1)}
                      primaryText={prestationType.value}
                      value={prestationType.uid}
                      key={i} />
                  ))
                }
              </SelectField>
            </div>

            <div 
                className='col-md-6 col-xs-12'
                style={{
                    width: '0px',
                    }}>
              <SelectField
                name='workflowSteps'
                sourceKey='workflowSteps'
                value={this.state.data.workflowSteps}
                multiple={true}
                onChange={this.handleMultiSelectChange}
                floatingLabelText={this.props.intl.formatMessage(constants.messages.STATUS_LABEL)}
              >
                {
                  this.props.workflowSteps.map((workflowStep, i) => (
                    <MenuItem
                      insetChildren={true}
                      checked={
                        !!(this.state.data.workflowSteps.length &&
                           this.state.data.workflowSteps.indexOf(workflowStep.name) > -1)}
                      primaryText={workflowStep.display_name}
                      value={workflowStep.name}
                      key={i} />
                  ))
                }
              </SelectField>
            </div>
          </div>
        </div>
      </Card>
    )
  }
}

const InfoTooltip = withStyles(() => ({
  tooltip: {
    width: 180,
    background: 'white',
    color: 'black',
    boxShadow: '0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)',
  },
}))(Tooltip);

const styles = {
  checkbox: {
    fontSize: 13,
    width: 'fit-content',
    whiteSpace: 'nowrap',
  },
  checkboxCell: {
    display: 'flex',
    alignItems: 'flex-end',
    paddingTop: '5px',
    paddingBottom: '10px',
  },
  infoIcon: {
    fontSize: '15px',
    position: 'relative',
    top: 3,
    zIndex: 1000,
    display: 'inline-block',
    overflow: 'visible',
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
  languages: state.ApplicantPrestation.languages,
  origines: state.ApplicantPrestation.origines,
  prestationTypes: state.ApplicantPrestation.prestationTypes,
  workflowSteps: state.ApplicantPrestation.workflowSteps
})

export default injectIntl(
  connect(
    mapStateToProps, 
    undefined
  )(SearchToolBar)
)



// WEBPACK FOOTER //
// ./src/components/common/prestation/SearchToolBar.js